import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { DATE_BY_STATUS } from "../../../constants/datesList";
import { useGetAgentsQuery } from "../../../redux/api/agentsApi";
import AutoComplete from "../../FormElements/AutoComplete";
import { useFormContext } from "react-hook-form";
import TaskFunnel from "../TaskFunnel";
import { useGetAgencyDashboardTasksStatusesQuery } from "../../../redux/api/authApi";
import BaseCard from "../../BaseCard/BaseCard";

export const RightSection = ({ agencyId, selectAll, setSelectAll }) => {
  const { data: agents, isFetching } = useGetAgentsQuery(agencyId);
  const { data: statuses } = useGetAgencyDashboardTasksStatusesQuery({
    agcId: agencyId,
  });
  const { watch } = useFormContext();
  const selectedAgentId = watch("agentid");
  const selectedAgent = agents?.find(
    (agent) => agent.agentid === selectedAgentId
  );

  const handleAgentChange = (agentId) => {
    if (agentId) {
      setSelectAll(false); // Uncheck "Select all" when agent is selected
    }
  };

  return (
    <Box>
      <Typography
        fontWeight="bold"
        sx={{
          mb: 1,
          backgroundColor: "#b5ffcb",
          p: 1,
          borderRadius: "5px",
          height: "40px",
          display: "flex",
          alignItems: "center",
        }}
      >
        Assigned To: {selectAll ? "All" : selectedAgent?.agentname || "None"}
      </Typography>

      <AutoComplete
        name="agentid"
        label="Search Staff"
        optionId="agentid"
        optionLabel="agentname"
        options={agents || []}
        isLoading={isFetching}
        sx={{ mb: 1 }}
        disabled={selectAll}
        onChangeCallback={handleAgentChange}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={selectAll}
            onChange={(e) => setSelectAll(e.target.checked)}
          />
        }
        label="Select all"
        sx={{ display: "block", ml: 0 }}
      />

      <TaskFunnel options={DATE_BY_STATUS} statuses={statuses} />
    </Box>
  );
};
